import { WorkingPage } from "../../../layouts/NotData";

const DomainNameserversTab = () => {
  return (
    <>
      <WorkingPage />
    </>
  );
};

export default DomainNameserversTab;
